import { EntityType } from '../../../shared/enums/entity-type.enum';
import { CalledConfigStatus } from '../enums/called-config-status.enum';

export class CalledConfig {
  id: number;
  entityType: EntityType;
  entityId: number;
  status: CalledConfigStatus;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (!this.status) {
      this.status = CalledConfigStatus.ACTIVE;
    }
  }

  toJson(): any {
    return {
      id: this.id || null,
      entityType: this.entityType,
      entityId: this.entityId,
      status: this.status,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/call-attendant/models/called-config.model.ts